
import {
  defineComponent, reactive, watch,
} from 'vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import { useModalBase } from '@/core/composables/ModalBase';
import { useGradeBase } from '@/core/composables/GradeBase';
import Icone from '@/core/components/Icone.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import storeSistema from '@/store/storeSistema';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import RequisicaoModal from '@/core/components/Modal/RequisicaoModal.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import SelecionarProduto from '@/components/Cadastros/Produtos/SelecionarProduto.vue';
import SelecionarUnidadeProdutoMovimento from '@/components/Cadastros/Produtos/Unidades/SelecionarUnidadeProdutoMovimento.vue';
import Card from '@/core/components/Tela/Card.vue';
import { IKitProdutos, IKitProdutosEmpresa, IKitProdutosItem } from '@/models/Entidades/Cadastros/Produtos/IKitProdutos';
import MensagemSemDados from '@/core/components/Tela/MensagemSemDados.vue';
import ServicoKitProdutos from '@/servicos/Cadastros/Produtos/ServicoKitProdutos';
import { EStatusRetornoRequisicao, IRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import SelecionarEmpresa from '@/components/MeuSistema/Empresas/SelecionarEmpresa.vue';
import { ETipoPermissao } from '@/models/Enumeradores/MeuSistema/Usuarios/ETipoPermissao';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';

export default defineComponent({
  name: 'KitsProdutosModal',
  props: {
    visivel: {
      type: Boolean,
      default: false,
    },
    empresa: {
      type: Number,
      required: true,
    },
    codigo: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Icone,
    Card,
    RequisicaoModal,
    CampoNumerico,
    SelecionarProduto,
    SelecionarUnidadeProdutoMovimento,
    MensagemSemDados,
    SelecionarEmpresa,
  },
  emits: ['update:visivel', 'confirmacao'],
  setup(props, { emit }) {
    const {
      telaBase, obterPermissoes, preencherEmpresasComEstrategiaPermissaoDados, verificaConceitoParaApresentarEmpresas,
      defineEmpresasSelecionadasCadastroCompartilhado, filtrarPermissaoDadosUsuarioMultiEmpresas,
      apresentarMensagemSucesso, apresentarMensagemAlerta,
    } = useTelaBase();
    const {
      modalBase, apresentarRetornoRequisicao, apresentarBarraProgresso, ocultarBarraProgresso,
    } = useModalBase(props, emit);
    const { gradeBase } = useGradeBase();
    const servicoKitProdutos = new ServicoKitProdutos();
    servicoKitProdutos.requisicaoSistema();
    telaBase.identificadorRecurso = 'CADASTRO_PRODUTOS_KITS';
    telaBase.identificadorPermissao = 'PER_CADASTRO_PRODUTOS_KITS';

    const state = reactive({
      kit: {} as IKitProdutos,
      produtoSelecionado: 0,
      descricaoProduto: '',
      unidadeSelecionada: 0,
      quantidade: 0,
      carregandoUnidade: false,
      descricaoUnidade: '',
      casasDecimais: 0,
    });

    function limparTela() {
      state.kit = {} as IKitProdutos;
      state.kit.itens = [] as IKitProdutosItem[];
      state.produtoSelecionado = 0;
      state.descricaoProduto = '';
      state.unidadeSelecionada = 0;
      state.quantidade = 0;
      state.carregandoUnidade = false;
      state.descricaoUnidade = '';
      state.casasDecimais = 0;
    }

    function adicionarItem() {
      if (state.produtoSelecionado === 0) {
        apresentarMensagemAlerta('O produto deve ser selecionado!');
        return;
      }

      if (state.unidadeSelecionada === 0) {
        apresentarMensagemAlerta('A unidade deve ser selecionada!');
        return;
      }

      if (state.quantidade === 0) {
        apresentarMensagemAlerta('A quantidade deve ser informada!');
        return;
      }

      const item = {} as IKitProdutosItem;
      item.codigoProdutoDefinicao = state.produtoSelecionado;
      item.codigoUnidade = state.unidadeSelecionada;
      item.descricaoProduto = state.descricaoProduto;
      item.descricaoUnidade = state.descricaoUnidade;
      item.quantidade = state.quantidade;
      item.casasDecimais = state.casasDecimais;
      state.kit.itens.push(item);

      state.produtoSelecionado = 0;
      state.unidadeSelecionada = 0;
      state.descricaoProduto = '';
      state.descricaoUnidade = '';
      state.quantidade = 0;
      state.casasDecimais = 0;
    }

    function removerItem(index: number) {
      state.kit.itens.splice(index, 1);
    }

    function validarCampos() {
      if (state.kit.descricao === '') {
        apresentarMensagemAlerta('A descrição do kit deve ser informada!');
        return false;
      }

      if (state.kit.itens.length === 0) {
        apresentarMensagemAlerta('Nenhum item foi informado no kit!');
        return false;
      }

      return true;
    }

    async function salvar() {
      let retorno: IRetornoRequisicao = { codigoRegistro: 0, status: 0, mensagem: '' };

      if (!validarCampos()) {
        return;
      }

      state.kit.empresas = [] as IKitProdutosEmpresa[];
      telaBase.empresasSelecionadas.forEach((e) => {
        const empresa = {} as IKitProdutosEmpresa;
        empresa.codigoEmpresa = e;
        empresa.codigoKitProdutos = props.codigo;
        state.kit.empresas.push(empresa);
      });

      apresentarBarraProgresso();
      if (props.codigo === 0) {
        retorno = await servicoKitProdutos.incluir(state.kit);
      } else {
        retorno = await servicoKitProdutos.alterar(state.kit);
      }
      ocultarBarraProgresso();
      if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
        emit('confirmacao');
        apresentarMensagemSucesso(retorno.mensagem);
        modalBase.computedVisivel = false;
      } else {
        apresentarRetornoRequisicao(retorno);
      }
    }

    watch(async () => modalBase.computedVisivel, async () => {
      telaBase.carregando = true;
      limparTela();
      if (modalBase.computedVisivel) {
        await obterPermissoes(ETipoPermissao.Dados);
        await preencherEmpresasComEstrategiaPermissaoDados(EPermissaoDados.Visualizar, true);

        if (props.codigo > 0) {
          state.kit = await servicoKitProdutos.obter(props.codigo, props.empresa);
          if (UtilitarioGeral.validaLista(state.kit.empresas)) {
            state.kit.empresas.forEach((k) => {
              telaBase.empresasSelecionadas.push(k.codigoEmpresa);
            });
          }
        } else {
          await defineEmpresasSelecionadasCadastroCompartilhado(props.empresa);
        }

        telaBase.permissaoDados = await filtrarPermissaoDadosUsuarioMultiEmpresas(telaBase.empresasSelecionadas);
        verificaConceitoParaApresentarEmpresas();
      }
      telaBase.carregando = false;
    });

    return {
      props,
      state,
      emit,
      telaBase,
      modalBase,
      gradeBase,
      storeSistema,
      UtilitarioData,
      UtilitarioMascara,
      UtilitarioGeral,
      adicionarItem,
      removerItem,
      salvar,
    };
  },
});
